import React from 'react'
import Link from 'gatsby-link';

const IndexPage = () => (
  <div>
    <header>
      <h1>Hi, I'm Jason</h1>
      <p>I am a developer, and I didn't give my self enough time to make this page pretty ;)</p>
    </header>
    <div>
      <Link to="/cotb2018">Code on the Beach 2018</Link>
    </div>
  </div>
)

export default IndexPage



// WEBPACK FOOTER //
// ./src/pages/index.js